<!-- 最新动态 -->
<template>
  <div class="w-full flex flex-col gap-4 py-6 bg-gray">
    <!-- 栏目标题 -->
    <div class="flex w-full justify-between pr-4 text-primary">
      <div class="flex flex-col px-4 items-left recentNewsTitle">
        <div class="text-lg font-bold">{{ info?.label }}</div>
        <div class="flex items-center gap-1">
          <div class="w-5 h-0.5 bg-primary" />
          <span class="text-xs font-semibold">{{ info?.englishName }}</span>
        </div>
      </div>

      <div class="flex items-center gap-1" @click="goMore(info?.id)">
        <img :src="require('@/assets/moreIcons.png')" alt="" />
        <span class="text-xs"> 查看更多</span>
      </div>
    </div>
    <!-- 菜单栏 -->
    <div class="flex items-center gap-6 px-2">
      <div
        v-for="item in menuList"
        :key="item?.name"
        @click="() => (activeMenuId = item?.id)"
        :class="[
          { 'text-primary': activeMenuId === item?.id },
          activeMenuId === item?.id ? 'font-bold' : 'font-normal',
        ]"
        :style="{
          borderBottomWidth: '2px',
          borderColor: activeMenuId === item?.id ? '#194E9E' : 'transparent',
          borderStyle: 'solid',
        }"
      >
        {{ item?.label }}
      </div>
    </div>
    <!-- 内容 -->
    <div
      class="flex flex-col px-4 rounded"
      v-for="item in pageInfoList"
      :key="item?.id"
      @click="() => handleNavigateToDetail(item?.id)"
    >
      <!-- 图片 -->
      <div class="w-full h-52">
        <img
          class="w-full h-full"
          :src="'/mainsys/UserFiles/menupic/' + item?.picUrl"
        />
      </div>
      <!-- 标题及描述 -->
      <div
        class="flex flex-col p-3 gap-1 bg-white"
        :class="{
          activeCardContent: acticveId === item?.id,
        }"
      >
        <!-- <span class="font-normal text-xs" :style="{
                    color: getColor(item?.descripton)
                }">
                    {{ item?.descripton }}
                </span> -->
        <span
          class="text-primary font-black text-base"
          :style="{
            color: '#13499B',
          }"
        >
          {{ item?.title }}
        </span>
        <span
          class="font-normal text-sm"
          style="
            color: #333333;
            opacity: 0.6;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          "
          >{{ item?.descripton }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { array_ } from "../utils/index";
import mixins from "../hooks";

export default {
  name: "learningResource",
  mixins: [mixins],
  props: {
    info: {
      default: () => ({}),
    },
  },
  computed: {
    // 菜单列表
    menuList() {
      return array_(this.info?.twoData).map((item) => {
        return {
          id: item?.id,
          label: item?.label,
        };
      });
    },
    // 不同菜单对应界面信息映射关系
    mappingPageInfo() {
      return array_(this.info?.twoData).reduce(
        (acc, cur) => acc.set(cur?.id, array_(cur?.data)),
        new Map()
      );
    },
    // 根据选择的菜单选择不同的pageInfo
    pageInfoList() {
      return this.mappingPageInfo?.get(this.activeMenuId).slice(0,3);
    },
    // 当前界面列表ID集合
    pageInfoIDList() {
      return array_(this.pageInfoList).map(({ id }) => id);
    },
  },
  data() {
    return {
      acticveId: null,
      activeMenuId: null,
    };
  },
  watch: {
    // 数据加载后,默认选中第一个
    menuList: {
      immediate: true,
      handler(val) {
        if (val?.length) {
          this.activeMenuId = val[0]?.id;
        }
      },
    },
  },

  methods: {
    goMore(id) {
      let ids = "";
      if (this.menuList && this.menuList.length > 0) {
        ids = this.menuList[0].id;
      } else {
        ids = id;
      }
      console.log(ids,'ids')
      this.$router.push({
        path: "ListTeach:menuId",
        name: "ListTeach",
        params: { menuId: ids },
      });
    },
    // 获取颜色
    getColor(str) {
      const regMap = [
        {
          reg: "省级一流",
          color: "#BB7915",
        },
        {
          reg: "国家一流",
          color: "#13499B ",
        },
      ];
      const color = array_(regMap).find(({ reg }) => str?.includes(reg))?.color;
      return color || "#13499B ";
    },
    // 切换选中信息板块
    handleChangeActiveId(id) {
      if (this.pageInfoIDList.includes(id)) {
        if (this.acticveId === id) {
          this.handleNavigateToDetail(id);
        } else {
          this.acticveId = id;
        }
      }
    },
  },
};
</script>
<style scoped>
.recentNewsTitle {
  background: url("~@/assets/title.png") no-repeat;
  background-size: 65% 100%;
}

.activeCardContent {
  background: url("~@/assets/bottomBg.jpg") no-repeat;
  background-size: cover;
}
</style>
